import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Button } from '../../../../components/molecules/Btn/Button';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { BtnModifier } from '../../../../components/molecules/Btn';
import { Icons } from '../../../../components/atoms/SVG';

export type AttributeGroupFormRemoveButton = {
  removeRule: () => void;
  position: number;
};

export function AttributeGroupFormRemoveButton({ removeRule, position }: AttributeGroupFormRemoveButton) {
  const { t } = useSonTranslation('AttributeGroups');

  return (
    <div className="attribute-group-form__button">
      <Button
        type="button"
        title={t('form.ruleset.remove', { position })}
        tooltipPlacement={TooltipPlacement.TOP}
        hideTooltipFromScreenReader
        modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
        onClick={() => removeRule()}
      >
        <Button.Icon svgSpriteId={Icons.DELETE_X_SMALL} text={t('form.ruleset.remove', { position })} />
      </Button>
    </div>
  );
}
